module.exports = __webpack_public_path__ + "static/img/bass.db5ea5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bass.png
// module id = bQIr
// module chunks = 0